<template>
  <div class="settingMessage"  v-if='boxData.judgeBox' :style="{'top': boxData.fix.y+'px', 'left': boxData.fix.x+'px', 'z-index': boxData.Zindex, }"  @mousedown="stopDocument($event)">
    <div class="dragArea" v-on:mousedown="moveStart($event, true)" v-on:mousemove="moveArea($event)" v-on:mouseup="saveMoveState($event)" :style="{'cursor': (boxData.moveoks?'move':'move')}">
      <i @click="close()" class="icon-popup-close"></i>
    </div>
    <div class="spriteBoody" @keydown.stop>

      <div 
        v-if="msgData.title"
        class="title"
      >
        
        {{msgData.title}}
        
      </div>

      <div class="cancel">
        <el-button
          v-if="msgData.leftTit"
          size="medium" 
          type="primary" 
          @click="close()"
        >
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {{msgData.leftTit}}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </el-button>
        <el-button
          v-if="msgData.rightTit"          
          size="medium" 
          type="primary" 
          @click="cancelScenes()"
        >
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          {{msgData.rightTit}}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        </el-button>
      </div>

    </div>
  </div>

</template>

<script>
import { mapGetters } from 'vuex'
import popupSecond from '../../mixins/popupSecond'

export default {
  mixins: [popupSecond],
  data() {
    return {
      boxDataName : 'settingMessage', // 弹窗名称
      boxName     : '',
      msgData    : {
        title: '',
        leftTit: '',
        rightTit: ' ',
      },
      oldItemMsg  : null, // 旧的数据
    };
  },
  watch : {
    'boxDatas.secondData' : function(val, oldval){ // 判断打开关闭
      let num = Array.indexOf(this.boxDatas.secondData, this.boxDataName);
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if(this.TOOL && this.boxData.judgeBox){ // 打开的操作
        this.boxData.Zindex   = (this.dataMsg.length + 1 )*5;
        this.boxData.data     = this.dataMsg[this.boxDataName].data;
        this.boxData.fix.x    = this.dataMsg[this.boxDataName].posx+2;
        this.boxData.fix.y    = this.dataMsg[this.boxDataName].posy+2;
        this.boxName          = this.dataMsg[this.boxDataName].boxName;
        this.msgData.title    = this.dataMsg[this.boxDataName].msg.title || '';
        this.msgData.leftTit  = this.dataMsg[this.boxDataName].msg.leftTit || '';
        this.msgData.rightTit = this.dataMsg[this.boxDataName].msg.rightTit || '';
      }
    },
  },
  props: [],
  computed: {
    ...mapGetters([
      'S_SearchData'
    ])
  },
  mounted () {
   this.$bus.on('settingMessage_vue',(data) => {
      if(this.TOOL && this.boxData.judgeBox && this.boxData.data.id !== data.data.id){ // 打开的操作

        this.boxData.data  = data.data;
        this.boxData.fix.x = data.posx+2;
        this.boxData.fix.y = data.posy+2;
        this.boxName       = data.boxName;
        this.msgData.title   = data.msg.title || '';
        this.msgData.leftTit = data.msg.leftTit || '';
        this.msgData.rightTit= data.msg.rightTit || '';
      }
    });
    this.$bus.on('windowMousedown_vue',(data) => {
        this.close();
    });
  },
  methods: {
    cancelScenes(){     // 取消收藏单个元素
      this.$bus.emit('settingMessage_del_vue',{
        type: this.boxName,
        data: this.boxData.data
      });
      this.close()
    },
    stopDocument(e){    // 防止事件冒泡
      e.stopPropagation();
    },
  },
  components: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
  .settingMessage{

    .spriteBoody{

      .title{

        .title-text{

          input{
            background: rgb(235,235,246);
            border: none;

          }
        }
      }

      .label{

        .label-text{

          input{
            height: 100%;
            padding: 0 2px;
          }
        }
      }
    }
  }

</style>
<style scoped lang="scss">
  .settingMessage{
    position: fixed;
    top: 0;
    left: 0;
    width: 450px;
    height: auto;
    z-index: 35;
    box-shadow: #d8dee9 0px 0px 5px 0px;
    border-radius: 6px 6px 3px 3px;
    border: 1px solid #d8dee9;
    background: #fff;
    overflow: hidden;
    .spriteBoody{
      .label,
      .title,
      .cancel{
        padding: 20px;
        height: 60px;
        position: relative;

        >span{
          position: absolute;
          top: 31px;
          left: 13px;
        }
      }
      .title{

        .title-text{
          width: 380px;
          margin-left: 33px;
        }
      }
      .label{
        height: auto;
        min-height: 40px;

        .labelBox{
          padding-bottom: 5px;
          display: flex;
          flex-wrap: wrap;
          width: 380px;
          margin-left: 33px;
          min-height: 40px;

          >*{
            margin-top: 5px;
            margin-left: 10px;
          }

          >div{
            margin-top: 9px;
            height: 30px;
            line-height: 20px;
            padding: 5px;
            background: rgb(233, 236, 247);
            border-radius: 10px;
            span{
              padding: 1px;
              color: #9c9797;
              font-weight: 900;
              font-size: 16px;
              position: relative;
              top: 2px;
              cursor: pointer;
              &:hover{
                background: #fff;
                border-radius: 100%;
              }
            }
          }

          .label-text{
            width: 88px;
            padding: 0;
            background: none;
          }
        }

      }
      .cancel{
        padding-top: 50px;
        min-height: 120px;
        >span{
          position: relative;
          display: inline-block;
          top: -3px;
          left: 0px;
          width: 112px;
          height: 30px;
          line-height: 30px;
          border-radius: 8px;
          background-color: #d8dee9;
          cursor: pointer;
          span{
            position: relative;
            display: inline-block;
            top: 2px;
            left: -5px;
            width: 15px;
            height: 15px;
            background: url('../../../../static/svg/heart.svg') no-repeat center;
          }

          &:hover{
            background: #b6c3da;
            span{
              background: url('../../../../static/svg/heart-active.svg') no-repeat center;
            }
          }
        }
      }
    }

    .dragArea{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 12px 0 15px;
      height: 28px;
      position: relative;

      i {
        position: absolute;
        right: 7px;
        top: 7px;
        display: inline-block;
        width: 12px;
        height: 12px;
        cursor: pointer;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/popups/secondPopups/settingMessage.vue